<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Export to Excel</v-card-title>

    <v-card-text>
         <v-list>
             <v-list-item>
               <v-list-item-avatar
                    v-if="running"
               > 
                    <v-progress-circular
                        :size="25"
                        :width="3"
                        color="primary"
                        indeterminate
                    />
                </v-list-item-avatar>

                <v-list-item-avatar
                    v-if="failed"
                > 
                    <v-icon>mdi-alert-circle-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-avatar
                    v-if="complete"
                > 
                    <v-icon
                        v-on:click="openFile"
                    >
                        mdi-microsoft-excel
                    </v-icon>
                </v-list-item-avatar>

                <v-list-item-content
                    v-if="!complete"
                >
                    <v-list-item-title v-text="last_signal.filename"></v-list-item-title>
                    <v-list-item-subtitle>{{status_string}}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-content
                    v-if="complete"
                    v-on:click="openFile"
                >
                    <v-list-item-title v-text="last_signal.filename"></v-list-item-title>
                </v-list-item-content>

             </v-list-item>
        </v-list>
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!complete"
        >
        Open File
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>


export default {
    data() {
        return {
            dialog: false,

            last_signal: {
                "signal_type" : "common-excel-export-progress",
                "organization_id" : "00000000-0000-0000-0000-000000000000",
                "blob_id" : "00000000-0000-0000-0000-000000000001",
                "filename" : "some file name",
                "state" : "running",
                "rows_created" : 0
            },


        }
    },

    created () {
        this.$event_bus.$on('excel-export-progress', this.updateProgress);
        this.$event_bus.$on('excel_export_dialog', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('excel-export-progress',this.updateProgress);
        this.$event_bus.$off('excel_export_dialog',this.showDialog);
    },

    methods: {
        showDialog(last_signal) 
        {
            this.last_signal = last_signal;

            this.dialog = true; 
        },

        openFile()
        {
            this.$rc.openBlob(this.last_signal.blob_object_name);
        },
        
        onOk()
        {
            this.openFile();
            this.dialog = false; 
        },

        updateProgress(signal)
        {
            if ( this.complete ) return; // in case of a rouge late signal...
            if ( signal.blob_id != this.last_signal.blob_id ) return;
            this.last_signal = signal;
        },
    },

    computed: {

        status_string() {
            if ( this.last_signal.state == 'complete' ) return "Complete";
            if ( this.last_signal.state == 'failed' ) return "Error -- export failed";

            return "Exporting ("+this.last_signal.rows_created+" rows created)";
        },

        running() {
            return this.last_signal.state == 'running';
        },

        complete() {
            return this.last_signal.state == 'complete';
        },

        failed() {
            return this.last_signal.state == 'failed';
        },
    },
}
</script>

<style lang="scss" scoped>

</style>